import { Box } from "@chakra-ui/react"
import dynamic from "next/dynamic"
import { useRouter } from "next/router"
import { useEffect } from "react"
import { useSetRecoilState } from "recoil"
import { ThemeProvider } from "styled-components"
import { activeArticleTableRowState } from "../../../common/store/articleTableStore"
import colors from "../../../theme/chakra/foundation/colors"
import brandColors from "../../../theme/chakra/foundation/colors-brand"
import theme from "../../../theme/emotion-theme"

const ArticleTableContainer = dynamic(() => import("./ArticleTableContainer"), { ssr: false })

export const ArticleTableWrapper = ({ articleTableData }) => {
  const { query, asPath } = useRouter()
  const brand = query.brand
  const setActiveArticleTableRowState = useSetRecoilState(activeArticleTableRowState)

  const brandedStyledComponentsTheme = {
    ...theme,
    colors: { ...colors, brand: brandColors[brand] }, // override with Chakra UI theme defined colors
  }

  // Reset the recoil state for the aricle table when the url changes
  useEffect(() => {
    setActiveArticleTableRowState(-1)
  }, [asPath])

  return (
    <ThemeProvider theme={brandedStyledComponentsTheme}>
      {/* This div is here so the styles for Firefox can work when openning the three dot menu */}
      <Box overflow="hidden">
        <ArticleTableContainer articleTableData={articleTableData} key={asPath} />
      </Box>
    </ThemeProvider>
  )
}
